import {IItemUiEnv} from "back/wsp/views/itemMain";
import {JSX} from "lib/commons/xml/dom";
import {ISearchCrit} from "lib/wsp/search";
import {SrcPointer, SrcPointerWriteAction} from "back/wsp/widgets/srcDrawer";
import {POPUP} from "back/commons/widgets/popups";
import {SkinClass, STYLER} from "lib/styler/styler";
import {OSkinSelectorEntry} from "dialogs/skinSelector";
import {JSrcFields, SRC} from "lib/wsp/src";
import {ERROR} from "lib/core/errorReport";
import {ITEM} from "lib/wsp/item";
import {ItemType} from "lib/wsp/wspMetaUi";

/**
 * Import d'un skin existant dans le contexte du reg du WSP
 */
export class StylerSrcImportSkin extends SrcPointerWriteAction {

	static SINGLETON = new StylerSrcImportSkin();

	customCrit?: ISearchCrit;

	constructor() {
		super("stylerImportSkin");
		this._label = "Importer un habillage graphique...";
		this._description = "Importer un habillage graphique présent dans ce contexte de travail";
		this._icon = "/@skin@/styler/actions/importSkin.svg";
		this._group = 'edit';
	}

	isVisible(ctx: SrcPointer): boolean {
		if (!ctx.getAttribute("data-styler-act")?.includes("importSkin") || !(ctx.reg.env as IItemUiEnv).longDesc || !((ctx.reg.env as IItemUiEnv).longDesc as any).itAttr_skClassStl) return false;
		return super.isVisible(ctx);
	}

	async execute(ctx: SrcPointer, ev?: Event) {
		const {SkinSelectorForSkinClassStl} = await import("back/styler/dialogs/skinSelector.js");
		const skinFromClassSelector = new SkinSelectorForSkinClassStl().initialize({
			skinClassStl: ((ctx.reg.env as IItemUiEnv).longDesc as any).itAttr_skClassStl,
			reg: ctx.reg,
			buttonLabel: "Importer ce style",
		});
		const skinClassStl = STYLER.getSkinClassStl(ctx.reg.env.wsp, ((ctx.reg.env as IItemUiEnv).longDesc as any).itAttr_skClassStl);
		const skinObj = await POPUP.showMenuFromEvent<OSkinSelectorEntry | null>(skinFromClassSelector, ev || ctx, ctx, {
			titleBar: {barLabel: {label: skinClassStl.name}}
		}).onNextClose();
		if (skinObj) {
			// # Upload du contenu

			const itTypeSgnMath = SkinClass.isSkinClassOdt(skinClassStl.skinClass(ctx.reg.env.wsp)) ? /@sf_skinOdt\b.*/ : /@sf_skinDoss\b.*/;
			const isZip: boolean = SkinClass.isSkinClassOdt(skinClassStl.skinClass(ctx.reg.env.wsp)) ? false : true;

			let data: Blob;
			let result: JSrcFields | null;
			try {
				const resp = await fetch(skinObj.resUrl, {
					method: 'get',
					//cache: "no-cache"
				});
				data = await resp.blob();
			} catch (e) {
				const skinName = skinObj.name;
				await ERROR.show(`Impossible d'importer l'habillage graphique '${skinName}'`, e);
				return;
			}
			if (data) {
				const {ItemCreator} = await import("back/wsp/dialogs/itemCreator.js");
				const ct = new ItemCreator().initialize(ItemCreator.setDefaultConfigFromReg(ctx.reg, {
					body: isZip ? null : data,
					itemTypesTree: {
						itemTypeReducer: (acc: ItemType[], cur: ItemType) => {
							if (cur.getSgn().match(itTypeSgnMath)) acc.push(cur);
							return acc;
						}
					},
					spaceUri: ctx.shortDescs.length > 0 ? ITEM.extractSpaceUri(ctx.shortDescs[0].srcUri) : "",
					nameBuilder: () => {return SRC.filterPartUri(skinClassStl.class + '_' + skinObj.code)}
				}));
				result = await POPUP.showDialog<JSrcFields>(ct, ctx.emitter, {titleBar: {barLabel: {label: "Importer un habillage graphique..."}}}).onNextClose();
			} else {
				const skinName = skinObj.name;
				await ERROR.show(`Impossible d'importer l'habillage graphique '${skinName}'`);
			}
			if (result) {
				if (isZip) await ITEM.importScar(ctx.reg.env.wsp, ctx, result.srcUri, new File([data], 'myFile'), true);//, progress.progressCallback
				ctx.focus();
				ctx.setSrcRef(ITEM.srcRefSub(result), result);
			}
		}

	}


}